
// --------------------------------------
// import { Component, HostListener, OnInit } from "@angular/core";
// import { OneSignal } from "onesignal-ngx";
// import { AngularFireMessaging } from "@angular/fire/compat/messaging";
// import { environment } from "src/environments/environments";

// @Component({
//   selector: "app-root",
//   templateUrl: "./app.component.html",
// })
// export class AppComponent implements OnInit {
//   messageReceived = false;
//   messageData: any = {};

//   @HostListener("window:beforeinstallprompt", ["$event"])
//   loadAPI: Promise<any>;

//   constructor(
//     private oneSignal: OneSignal,
//     private afMessaging: AngularFireMessaging
//   ) {
//     this.loadAPI = new Promise((resolve) => {
//       this.loadScript();
//       resolve(true);
//     });
//   }

//   ngOnInit() {

//     this.initFirebaseMessaging();
//     this.initOneSignal();
//     this.requestPermission();
//   }

//   initOneSignal() {
//     this.oneSignal.init({
//       appId: environment.OneSignalAppId,
//       autoRegister: false,
//       notifyButton: { enable: true },
//     });

//     this.oneSignal.showSlidedownPrompt();

//     this.oneSignal.isPushNotificationsEnabled().then((enabled) => {
//       if (!enabled) {
//         this.oneSignal.registerForPushNotifications().then(() => {
//           this.setExternalUserIdIfAvailable();
//         });
//       } else {
//         this.setExternalUserIdIfAvailable();
//       }
//     });

//     this.oneSignal.on('notificationDisplay', (event: any) => {
//       console.log("OneSignal Notification:", event);
//     });

//     this.oneSignal.getUserId().then((playerId) => {
//       if (playerId) {
//         localStorage.setItem("player_id", playerId);
//       }
//     });
//   }

//   setExternalUserIdIfAvailable() {
//     const userId = localStorage.getItem("_restId");
//     const userType = localStorage.getItem("type");

//     if (userId) {
//       this.oneSignal.setExternalUserId(userId);
//     }

//     if (userType) {
//       this.oneSignal.sendTag("user_type", userType);
//     }
//   }

//   removeExternalUserId() {
//     this.oneSignal.removeExternalUserId();
//     this.oneSignal.deleteTag("user_type");
//   }

//   //   initFirebaseMessaging() {
//   //     this.afMessaging.messages.subscribe((payload: any) => {
//   //       console.log("📩 Firebase Message:", payload);

//   //       const userType = localStorage.getItem("type");
//   //       let icon = "assets/images/logo.png";
//   //       if (userType === "laundry") icon = "assets/images/laundry-icon.png";
//   //       else if (userType === "apartment") icon = "assets/images/apartment-icon.png";
//   //       else if (userType === "restaurant") icon = "assets/images/restaurant-icon.png";

//   //       const notification = new Notification(payload.notification.title, {
//   //         body: payload.notification.body,
//   //         icon: icon,
//   //       });

//   //     notification.onclick = () => {
//   //   const userType = localStorage.getItem("type"); 

//   //   if (userType === "apartment") {
//   //     window.location.href = "/room-new-order";
//   //   } else if (userType === "laundry") {
//   //     window.location.href = "/dashboard-laundry";
//   //   } else if (userType === "restaurant") {
//   //     window.location.href = "/restaurant-dashboard";
//   //   } else {
//   //     window.location.href = "/dashboard"; // default fallback
//   //   }
//   // };


//   //       this.messageReceived = true;
//   //       this.messageData = payload.notification;
//   //     });
//   //   }

//   //   requestPermission() {
//   //     if ("Notification" in window) {
//   //       Notification.requestPermission().then((permission) => {
//   //         if (permission === "granted") {
//   //           this.afMessaging.requestToken.subscribe({
//   //             next: (token) => {
//   //               localStorage.setItem("FCM_Token", token);
//   //               console.log("✅ FCM Token:", token);
//   //             },
//   //             error: (err) => {
//   //               console.error("❌ FCM Token Error:", err);
//   //             },
//   //           });
//   //         }
//   //       });
//   //     }
//   //   }

//   initFirebaseMessaging() {
//     this.afMessaging.messages.subscribe((payload: any) => {
//       console.log("📩 Firebase Message:", payload);

//       const userType = localStorage.getItem("type");
//       let icon = "assets/images/logo.png";
//       if (userType === "laundry") icon = "assets/images/laundry-icon.png";
//       else if (userType === "apartment") icon = "assets/images/apartment-icon.png";
//       else if (userType === "restaurant") icon = "assets/images/restaurant-icon.png";

//       const notification = new Notification(payload.notification.title, {
//         body: payload.notification.body,
//         icon: icon,
//       });

//       this.playCustomSound();

//       notification.onclick = () => {
//         if (userType === "apartment") {
//           window.location.href = "/room-new-order";
//         } else if (userType === "laundry") {
//           window.location.href = "/dashboard-laundry";
//         } else if (userType === "restaurant") {
//           window.location.href = "/restaurant-dashboard";
//         } else {
//           window.location.href = "/dashboard";
//         }
//         notification.close();
//       };

//       this.messageReceived = true;
//       this.messageData = payload.notification;
//     });
//   }

//   requestPermission() {
//     if ("Notification" in window) {
//       Notification.requestPermission().then((permission) => {
//         if (permission === "granted") {
//           this.afMessaging.requestToken.subscribe({
//             next: (token) => {
//               localStorage.setItem("FCM_Token", token);
//               console.log("✅ FCM Token:", token);
//             },
//             error: (err) => {
//               console.error("❌ FCM Token Error:", err);
//             },
//           });
//         } else {
//           console.warn("❌ Notification permission denied");
//           localStorage.removeItem("FCM_Token");
//         }
//       });
//     }
//   }

//   playCustomSound() {
//     const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
//     const audioContext = new AudioContext();

//     if (audioContext.state === 'suspended') {
//       audioContext.resume();
//     }

//     const soundUrl = "assets/images/Best Windows Message.mp3";
//     fetch(soundUrl)
//       .then(res => res.arrayBuffer())
//       .then(buffer => audioContext.decodeAudioData(buffer))
//       .then(decoded => {
//         const source = audioContext.createBufferSource();
//         source.buffer = decoded;
//         source.connect(audioContext.destination);
//         source.start();
//       })
//       .catch(err => console.error("Sound error:", err));
//   }
//   loadScript() {
//     const scripts = [
//       "assets/js/jquery.min.js",
//       "assets/js/bootstrap.min.js",
//       "assets/js/slick.min.js",
//     ];

//     scripts.forEach((src) => {
//       const script = document.createElement("script");
//       script.src = src;
//       script.type = "text/javascript";
//       script.async = false;
//       document.body.appendChild(script);
//     });
//   }
// }
// -------------------------------------------------------------




import { Component, OnInit } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { UserService } from './services/user.service';
// import { OneSignal } from 'onesignal-ngx';
import { environment } from 'src/environments/environments';
import { SocketService } from './services/socket.service';
// import { OneSignalService } from './services/onesignal.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  messageReceived = false;
  messageData: any = {};
  loadAPI: Promise<any>;

  constructor(
    // private oneSignal: OneSignal,
    private afMessaging: AngularFireMessaging,
    private api: UserService,
    private socketService: SocketService,
    // private oneSignalService: OneSignalService
  ) {
    this.loadAPI = new Promise((resolve) => {
      this.loadScript();
      resolve(true);
    });
  }

  ngOnInit() {
    this.initFirebaseMessaging();
    // this.initOneSignal();
    this.requestPermission();
    this.initSocket();
  }

  initSocket() {
    const authToken = localStorage.getItem(`${environment.appName}` + 'user');
    if (authToken) {
      this.socketService.connect(authToken);
    }
  }

  // async initOneSignal(): Promise<void> {

  //   await this.oneSignalService.init();

  //   const userId = localStorage.getItem('_restId');
  //   const userType = localStorage.getItem('type');

  //   if (userId) {
  //     await this.oneSignalService.login(userId);
  //   }

  //   if (userType) {
  //     await this.oneSignalService.setUserType(userType);
  //   }

  //   const playerId = this.oneSignalService.getPlayerId();
  //   if (playerId && userId && userType) {
  //     // call your API
  //     this.api.createOneSignal(userId, playerId, userType).subscribe();
  //   }
  // }

  //recent commit name checking for already intilaised in onesignal service and comented  
//  async initOneSignal(): Promise<void> {
//   await this.oneSignalService.init();

//   const userId = localStorage.getItem('_restId');
//   const userType = localStorage.getItem('type');
//   const alreadyLinked = localStorage.getItem('player_id'); // ✅ add this

//   if (!userId) {
//     console.warn("⚠️ No userId at app init");
//     return;
//   }

//   if (alreadyLinked) {
//     console.log("⏭️ Already linked — skipping");
//     return; // ✅ add this
//   }

//   await this.oneSignalService.login(userId);
//   if (userType) await this.oneSignalService.setUserType(userType);

//   const playerId = (window as any).OneSignal?.User?.PushSubscription?.id;
//   console.log("🎮 app playerId:", playerId);

//   if (playerId) {
//     localStorage.setItem('player_id', playerId);
//     this.api.createOneSignal(userId, playerId, userType || '').subscribe({
//       next: (res) => console.log("✅ app OneSignal linked:", res),
//       error: (err) => console.error("❌ app error:", err)
//     });
//   }
// }

// async initOneSignal(): Promise<void> {
//   await this.oneSignalService.init();
//   const userId = localStorage.getItem('_restId');
//   const userType = localStorage.getItem('type');
//   const alreadyLinked = localStorage.getItem('player_id');
//   if (!userId) { console.warn("⚠️ No userId at app init"); return; }
//   if (alreadyLinked) { console.log("⏭️ Already linked — skipping"); return; }
//   await this.oneSignalService.login(userId);
//   if (userType) await this.oneSignalService.setUserType(userType);
//   const playerId = await this.waitForPlayerId();
//   if (playerId) {
//     localStorage.setItem('player_id', playerId);
//     this.api.createFcm(userId, playerId, userType || '').subscribe({
//       next: (res) => console.log("✅ app OneSignal linked:", res),
//       error: (err) => console.error("❌ app error:", err)
//     });
//   }
// }

// private waitForPlayerId(retries = 10): Promise<string | null> {
//   return new Promise((resolve) => {
//     let attempts = 0;
//     const interval = setInterval(() => {
//       const playerId = (window as any).OneSignal?.User?.PushSubscription?.id;
//       if (playerId) { clearInterval(interval); resolve(playerId); return; }
//       attempts++;
//       if (attempts >= retries) { clearInterval(interval); resolve(null); }
//     }, 1000);
//   });
// }



  // initOneSignal() {
  //   this.oneSignal.init({
  //     appId: environment.OneSignalAppId,
  //     autoRegister: false,
  //     autoResubscribe: true,
  //     notifyButton: { enable: true, displayPredicate: () => true },
  //     allowLocalhostAsSecureOrigin: true,
  //   });

  //   // this.oneSignal.showSlidedownPrompt();
  //   // setTimeout(() => {
  //   //   this.attachUserIfExists();
  //   // }, 1000);
  //   this.oneSignal.isPushNotificationsEnabled().then((enabled) => {
  //     if (!enabled) {
  //       // this.oneSignal.registerForPushNotifications().then(() => {
  //       //   this.setExternalUserIdIfAvailable();
  //       // });
  //        this.oneSignal.showNativePrompt();
  //     } else {
  //       this.setExternalUserIdIfAvailable();
  //     }
  //   });

  //   this.oneSignal.on('notificationDisplay', (event: any) => {
  //     console.log("OneSignal Notification:", event);
  //   });

  //   // ✅ Fetch player_id and call your API
  //   this.oneSignal.getUserId().then((playerId) => {
  //     if (playerId) {
  //       localStorage.setItem("player_id", playerId);

  //       const userId = localStorage.getItem("_restId");
  //       const userType = localStorage.getItem("type");
  //       console.log("✅ OneSignal player_id linked to user:");
  //       if (userId && userType) {
  //         this.api.createOneSignal(userId, playerId, userType).subscribe({
  //           next: (res) => {
  //             console.log("✅ OneSignal player_id linked to user:", res);
  //           },
  //           error: (err) => {
  //             console.error("❌ OneSignal API error:", err);
  //           }
  //         });
  //       }
  //     }
  //   });
  // }

  // attachUserIfExists() {
  //   const userId = localStorage.getItem("_restId");
  //   const userType = localStorage.getItem("type");
  //   if (!userId) return;
  //   this.oneSignal.setExternalUserId(userId);
  //   if (userType) { this.oneSignal.sendTag("user_type", userType); }
  //   this.oneSignal.getUserId().then(playerId => {
  //     if (playerId) { localStorage.setItem("player_id", playerId); }
  //   });
  // }

  // setupOneSignalAfterLogin() {
  //   const userId = localStorage.getItem("_restId");
  //   const userType = localStorage.getItem("type");
  //   if (userId) {
  //     this.oneSignal.setExternalUserId(userId);
  //     if (userType) this.oneSignal.sendTag("user_type", userType);
  //     this.oneSignal.getUserId().then((playerId) => {
  //       if (playerId) {
  //         localStorage.setItem("player_id", playerId);
  //         this.api.createFcm(userId, playerId, userType || '').subscribe();
  //       }
  //     });
  //   }
  // }

  // setExternalUserIdIfAvailable() {
  //   const userId = localStorage.getItem("_restId");
  //   const userType = localStorage.getItem("type");
  //   if (userId) { this.oneSignal.setExternalUserId(userId); }
  //   if (userType) { this.oneSignal.sendTag("user_type", userType); }
  // }

  // removeExternalUserId() {
  //   this.oneSignal.removeExternalUserId();
  //   this.oneSignal.deleteTag("user_type");
  // }




  initFirebaseMessaging() {
    this.afMessaging.messages.subscribe((payload: any) => {
      console.log("📩 Firebase Message:", payload);

      const userType = localStorage.getItem("type");
      const apartment_type = localStorage.getItem("apartment_type");
      const icon = "assets/images/favicon.png";

      const title = payload.notification?.title || payload.data?.title;
      const body = payload.notification?.body || payload.data?.body;

      if (!title) return;

      const notification = new Notification(title, {
        body: body,
        icon: icon,
      });

      // setTimeout(() => {
      //   this.playCustomSound();
      // }, 500);

      notification.onclick = () => {
        if (userType === "apartment" && apartment_type == 'residential') {
          window.location.href = "/resident-new-order";
        } else if (userType === "apartment") {
          window.location.href = "/room-new-order";
        } else if (userType === "laundry") {
          window.location.href = "/dashboard-laundry";
        } else if (userType === "restaurant") {
          window.location.href = "/restaurant-dashboard";
        } else if (userType === "club") {
          window.location.href = "/club/slot-generation";
        } else {
          window.location.href = "/dashboard";
        }
        notification.close();
      };

      this.messageReceived = true;
      this.messageData = { title, body };
    });
  }


  requestPermission() {
    if (!("Notification" in window)) return;

    // Only attempt to save FCM token to backend if user is authenticated
    const authToken = localStorage.getItem(`${environment.appName}` + 'user');
    if (!authToken) return; // Not logged in — skip to avoid 401 loop

    // The user explicitly unsubscribed from the notification bell — respect
    // that until they re-subscribe or log in again, otherwise every refresh
    // silently re-requests a token and re-registers them (site-headers.component.ts
    // sets/clears this flag from toggleSubscription()).
    if (localStorage.getItem('notif_opted_out') === '1') return;

    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        this.afMessaging.requestToken.subscribe({
          next: (token) => {
            if (!token) return;
            const existingToken = localStorage.getItem("FCM_Token");
            if (existingToken === token) return; // token unchanged, skip API call
            localStorage.setItem("FCM_Token", token);
            const userId = localStorage.getItem('_restId');
            const userType = localStorage.getItem('type');
            if (userId && userType) {
              this.api.createFcm(userId, token, userType).subscribe({
                next: () => {},
                error: (err) => console.error('❌ FCM save error on app init:', err)
              });
            }
          },
          error: (err) => console.error("❌ FCM Token Error:", err),
        });
      } else {
        localStorage.removeItem("FCM_Token");
      }
    });
  }



  playCustomSound() {
    console.log("🔊 Attempting to play sound...");

    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    const audioContext = new AudioContext();

    // Ensure context is resumed
    if (audioContext.state === 'suspended') {
      audioContext.resume().then(() => {
        console.log("🎵 Audio context resumed");
      });
    }

    const soundUrl = "/assets/images/new_order.mp3"; // Use absolute path for reliability

    fetch(soundUrl)
      .then(res => res.arrayBuffer())
      .then(buffer => audioContext.decodeAudioData(buffer))
      .then(decoded => {
        const source = audioContext.createBufferSource();
        source.buffer = decoded;
        source.connect(audioContext.destination);
        source.start();
        console.log("✅ Sound played!");
      })
      .catch(err => console.error("🔇 Sound error:", err));
  }


  loadScript() {
    const scripts = [
      "assets/js/jquery.min.js",
      "assets/js/bootstrap.min.js",
      "assets/js/slick.min.js",
    ];

    scripts.forEach((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.type = "text/javascript";
      script.async = false;
      document.body.appendChild(script);
    });
  }
}
